import { useSeo } from "@/lib/seo";
import { CONTACT } from "@/data/site";
import { PageHeader } from "@/components/site/PageHeader";

export default function Privacy() {
  useSeo({
    title: "Privacy",
    description: "How Selling Sunsets handles the information you share through enquiries and the guided intelligence tool.",
    path: "/privacy",
  });

  return (
    <>
      <PageHeader
        eyebrow="Privacy"
        marker="SS·PRV"
        title="Privacy & your information"
        intro="A plain-language summary of how we handle the information you choose to share with us."
        breadcrumbs={[{ label: "Privacy" }]}
      />
      <section className="ss-container-text pb-28 space-y-6 text-[1.05rem] font-light leading-[1.8] text-[#3a3f44]">
        <p>Selling Sunsets collects only the information you voluntarily provide — typically your name, email, an optional phone number, a location of interest, and the details of your enquiry or guided-intelligence answers.</p>
        <h2 className="font-display text-2xl font-normal text-[#1A1C1E] pt-4">How we use it</h2>
        <p>We use your information solely to respond to your enquiry and to provide buyer-side advisory. We do not sell your data, and we do not share it with sellers, developers or third parties for marketing.</p>
        <h2 className="font-display text-2xl font-normal text-[#1A1C1E] pt-4">Retention</h2>
        <p>We retain enquiry information for as long as needed to assist you and to maintain a record of our advisory relationship. You may ask us to delete your information at any time.</p>
        <h2 className="font-display text-2xl font-normal text-[#1A1C1E] pt-4">Contact</h2>
        <p>For any privacy question, or to request deletion of your data, contact us at <a href={`mailto:${CONTACT.email}`} className="ss-link text-[#1A1C1E]">{CONTACT.email}</a>.</p>
        <p className="text-[0.9rem] text-[#8A9098] italic pt-6">This summary is provided for transparency during development and will be reviewed before public launch.</p>
      </section>
    </>
  );
}
